import { StorageObjectGroupType } from '@navio/nsdk';
import type { NoddiIconName } from 'noddi-ui-common';

export const STORAGE_OBJECT_GROUP_TYPE_ICON: Record<StorageObjectGroupType, NoddiIconName> = {
  [StorageObjectGroupType.CAR_WHEELS]: 'Wheel',
  [StorageObjectGroupType.CAR_TIRES]: 'Target'
};
